<template lang="pug">
div
  .month.mb-4
    v-btn.rounded.mr-2(fab x-small tile color="primary" @click="prev")
      v-icon mdi-chevron-left

    v-btn.rounded.mr-2(fab x-small tile color="primary" @click="next")
      v-icon mdi-chevron-right

    h6.text-h6.caption.mr-auto
      |  {{ MONTHS[currentDate.getMonth()] }} {{ currentDate.getFullYear() }}
    .flex-grow-1

    //- v-btn(color="success").mr-2 Всего: {{ schedules.length }}
</template>
<script>
import {
  addMonths, addWeeks, subMonths, subWeeks,
} from 'date-fns';
import { VIEW_TYPES, VIEW_TYPES_TEXT } from '../constants';
import { MONTHS } from '@/constants';
import SelectScheduleType from '@/components/inputs/SelectScheduleType.vue';

const DEFAULT_FIELDS = {
  name:'',
  type: null,
  organization_name: '',
  user_full_name: '',
};

export default {
  components:{ SelectScheduleType },
  props: {
    currentDate: { type: [String, Date], required: true },
    type: { type: [String, Date], required: true },
    schedules: { type: [String, Object, Array], required: true },
  },
  data() {
    return {
      MONTHS,
      VIEW_TYPES,
      VIEW_TYPES_TEXT,
      searchFields: {
        ...DEFAULT_FIELDS,
      },
    };
  },
  computed:{
    viewTypes() {
      return Object.keys(this.VIEW_TYPES_TEXT).map((key) => ({ value: key, text: this.VIEW_TYPES_TEXT[key] }));
    },
    month() {
      return MONTHS[this.currentDate.getMonth()];
    },
    hasSearchValues() {
      return Object.keys(this.searchFields).some((key) => this.searchFields[key]);
    },
  },
  watch:{
    searchFields: {
      deep: true,
      handler(v) {
        this.$emit('set-filters', v);
      },
    },
  },
  methods:{
    clearFilter() {
      this.searchFields = { ...DEFAULT_FIELDS };
    },
    next() {
      const add = {
        [VIEW_TYPES.MONTH]: addMonths,
        [VIEW_TYPES.WEEK]: addWeeks,
      };

      this.$emit('set-day', add[this.type](this.currentDate, 1));
    },
    prev() {
      const sub = {
        [VIEW_TYPES.MONTH]: subMonths,
        [VIEW_TYPES.WEEK]: subWeeks,
      };

      this.$emit('set-day', sub[this.type](this.currentDate, 1));
    },
  },

};
</script>

<style lang="scss">
.month {
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
